<template>  
  <div>
    <menu-common-users 
      v-if="isAdmin && isCommonMenus"
      :menuID="editTMP.ID"
      v-model="editTMP.UsersMenusCommon"
    />
    <div
      class="text-right pt-2"
      style="padding: 10px;"
    >
    <v-layout
      wrap
      v-if="(isAdmin && contents.length === 0 && editTMP.Type !== 1) || editTMP.WebAppAsContent"
    >
      <v-flex
        xs6
      >
        <v-switch
          v-model="editTMP.WebAppAsContent"
          :label="$t('menus.WAAsContent')"
          :color="enterpriseColor"
          hide-details
          @change="handleChangeWebAppAsContent"
        />
      <v-switch
          v-if="editTMP.WebAppAsContent"
          v-model="editTMP.WebAppAsLink"
          label="link"
          :color="enterpriseColor"
          hide-details
          @change="handleChangeWebAppAsLink"
        />
      </v-flex>
      <v-flex
        v-if="editTMP.WebAppAsContent"
        xs6
      >
        <v-text-field
          v-model="editTMP.WebAppAsContentDomain"
          :label="$t('menus.domain')"
        />
      </v-flex>
    </v-layout>
    </div>
    <div
      class="text-right pt-2"
      style="padding: 10px 10px 0 10px;"
    >
      <translate
        v-model="editTMP.Name"
        :languages="languages"
        :label="$t(editTMP.isSecundary ? 'menus.submenuName': 'menus.menuName')"
        @input="handleChangeIsModified"
      />
    </div>
    <div
      class="text-left pt-2"
      style="padding: 0 0 10px 0;"
    >
    <small style="color: #00000087;">Logo menú</small>
      <select-image
        v-show="!collapseContent"
        v-model="editTMP.Image"
        :isFullWidth="true"
        :enterpriseID="enterpriseID"
        :imageOld='editTMP.Image'
        @input="handleChangeIsModified"
        style="margin-left:0px;margin-top:15px;margin-right: 0px;"
        width="100px"
      />
    </div>
    <div
      v-if="isCommonMenus"
      class="text-right pt-2"
    >
      <v-text-field
        v-model="editTMP.Alias"
        :label="$t('commonMenus.alias')"
      />
    </div>
    <v-tooltip
      bottom 
      v-if="editTMP"
    > 
      <template v-slot:activator="{ on }">
        <div
          class="text-left pt-2"
          style="margin-bottom: 15px;"
          v-on="editTMP.isNew ? on : null"
        >
          <v-layout wrap>
            <v-flex xs5 v-if="!editTMP.WebAppAsContent">
              <v-btn
                v-if="editTMP.isSecundary"
                :dark="!editTMP.isNew"
                :color="enterpriseColor"
                :disabled="editTMP.isNew"
                @click="handleAddContent(editTMP.Type)"
              >
                {{ $t('common.addToSubmenu', locale)}}
              </v-btn>
              <v-btn
                v-else-if="editTMP.Type === 1"
                :dark="!editTMP.isNew"
                :color="enterpriseColor"
                :disabled="editTMP.isNew"
                @click="handleAddContent(editTMP.Type)"
              >
                <v-icon>mdi-plus</v-icon> {{ $t('common.addSubmenu', locale)}}
              </v-btn>
              <v-btn
                v-else
                :dark="!editTMP.isNew"
                :color="enterpriseColor"
                :disabled="editTMP.isNew"
                @click="handleAddContent(editTMP.Type)"
              >
                {{ $t('common.addContent', locale)}}
              </v-btn>
            </v-flex>
            <v-flex xs5 v-else />
            <v-flex xs2>
              
            </v-flex>
            <v-flex xs5>
              <!-- <v-btn
                v-if="editTMP.Type !== 1"
                :dark="!editTMP.isNew"
                color="primary"
                :disabled="editTMP.isNew"
                @click="handleCollapseContent"
                style="margin-left: 15px"
              >
                <v-icon>{{ collapseContent ? 'mdi-arrow-expand-vertical' : 'mdi-arrow-collapse-vertical' }}</v-icon>
                {{ $t(`common.${collapseContent ? 'expand' : 'collapse'}`)}}
              </v-btn> -->
              <!-- <div
                style="text-align: right;width: 40px"
              > -->
                <v-switch
                  v-if="editTMP.Type !== 1 && contents && contents.length > 0"
                  :value="collapseContent"
                  :label="$t('common.collapse')"
                  :color="enterpriseColor"
                  hide-details
                  style="margin-top: 0px;float: right; margin-right: 10px;"
                  @change="handleCollapseContent"
                />
                <v-switch
                  v-if="authType !== 'none'"
                  v-model="editTMP.Private"
                  :label="$t('common.private')"
                  :color="enterpriseColor"
                  hide-details
                  style="margin-top: 0px;float: right; margin-right: 10px;"
                />
              <!-- </div> -->
            </v-flex>

            <!-- colors -->
            <v-flex xs3 style="margin-top:10px">
              {{$t('common.menu', locale)}}:
            </v-flex>
            <v-flex xs3 style="margin-top:10px">
              <custom-color-picker-background-and-text
                v-if="showCustomColorMenu"
                style="width: 100px;"
                :BGColor="editTMP.BGColor"
                :TextColor="editTMP.TextColor"
                :onChangeColor="handleChangeCustomMenuColor"
              />
            </v-flex>
            <v-flex xs3 style="margin-top:10px">
              {{$t('common.content', locale)}}:
            </v-flex>
            <v-flex xs3 style="margin-top:10px">
              <custom-color-picker-background-and-text
                v-if="showCustomColorMenu"
                style="width: 100px;"
                :BGColor="editTMP.BGColorContent"
                :TextColor="editTMP.TextColorContent"
                :onChangeColor="handleChangeCustomContentColor"
              />
            </v-flex>
            <!-- colors -->
          </v-layout>
          <menu-type
            :type="editTMP.Type"
            :isSecundary="editTMP.isSecundary"
            :showMenuType="showMenuType"
            :onCloseMenuType="handleCloseMenuType"
            :locale="locale"
            />
        </div>
      </template>
      <span>{{ $t('menus.info.saveBeforeEdit') }}</span>
    </v-tooltip>
    <!-- si es de tipo submenu y NO tiene elementos agregados -->
    <v-card v-if="editTMP.Type === 1 && (!editTMP.Menus || editTMP.Menus.length === 0)" style="padding: 5px 10px 10px 10px;margin-bottom: 15px;">
      <div
        class="text-left pt-2"
        style="margin-bottom: 20px;"
      >
        <h5>{{$t('menus.submenus')}}</h5>
      </div>
      <center>{{ $t('menus.info.noExistSubmenu') }}</center>
    </v-card>
    <!-- si es de tipo submenu y tiene elementos agregados -->
    <v-card v-if="!editTMP.WebAppAsContent && editTMP.Type === 1 && editTMP.Menus && editTMP.Menus.length > 0" style="padding: 5px 10px 10px 10px;margin-bottom: 15px;">
      <div
        class="text-left pt-2"
        style="margin-bottom: 20px;"
      >
        <h5>{{$t('menus.submenus', locale)}}</h5>
      </div>
      <draggable
        class="list-group"q
        v-model="editTMP.Menus"
        group="content"
        draggable=".list-group-item"
        @start="dragging = true"
        @end="dragging = false"
        @change="handleChangeSort"
      >
        <transition-group type="transition" :name="!dragging ? 'flip-list' : null">
          <form-header
            class="list-group-item"
            v-for="(item, index) in editTMP.Menus"
            :key="`submenu${index}`"
            :editTMP="item"
            :showEdits="true"
            :onEdit="onEdit"
          />
        </transition-group>
      </draggable>
    </v-card>
    <form-content
      v-if="editTMP.Type === 0 && !editTMP.isNew"
      :scrollPosition="scrollPosition"
    />
    <v-divider v-if="!editTMP.Menus && !contents" style="margin-bottom: 10px;"/>
    <modal-loading />
    <action-button 
      :onAdd="handleAddContent"
      :onDelete="handleShowDeleteModal"
      :onCancel="handleClear"
      :onSave="handleSubmit"
    />
    <v-flex xs12>
      <v-switch
        v-if="editTMP.Type !== 1 && contents && contents.length > 0"
        :value="collapseContent"
        :label="$t('common.collapse')"
        :color="enterpriseColor"
        hide-details
        style="margin-bottom:15px;margin-top: -15px;float: right; margin-right: 10px;"
        @change="handleCollapseContent"
      />
    </v-flex>
    <table width="100%" style="z-index:3">
      <tr>
        <td>
          <v-switch
            v-if="!editTMP.isNew"
            v-model="editTMP.IsTemp"
            :label="$t(editTMP.isSecundary ? 'menus.isSubmenuTemp' : 'menus.isMenuTemp')"
            :color="enterpriseColor"
            hide-details
            @change="handleChangeIsTemp"
          />
        </td>
        <td style="text-align=right;">
          <div
            class="text-right pt-2"
            :style="{ 'margin-bottom': editTMP.IsTemp ? '15px' : '0px' }"
          >
            <v-btn v-if="!editTMP.isNew" color="red darken-1" dark class="mr-4" @click="handleShowDeleteModal">{{ $t('common.delete') }}</v-btn>
            <v-btn class="mr-4" @click="handleClear">{{ $t('common.cancel') }}</v-btn>
            <v-btn dark :color="enterpriseColor" @click="handleSubmit" :disabled="saving" :loading="saving">{{ $t('common.save') }}</v-btn>
          </div>
        </td>
      </tr>
    </table>
    <availability
      v-if="editTMP.IsTemp"
      :editTMP="editTMP"
      :onChange="handleUpdateAvailability"
    />
    <confirm-delete 
      :showDialog="showConfirmDelete"
      :onKO="handleCancelDelete"
      :onOK="handleDelete"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import ConfirmDelete from '@/components/ConfirmDelete'
  import FormHeader from './FormHeader'
  import MenuType from './MenuType'
  import ActionButton from './ActionButton'
  import Availability from './availability/Index'
  import Translate from '@/components/Translate'
  import utils from '@/services/utils.js'
  import FormContent from './content/Index'
  import draggable from 'vuedraggable'
  import ModalLoading from '@/components/ModalLoading'
  import CustomColorPickerBGAndText from '@/components/CustomColorPickerBGAndText'
  import SelectImage from '@/components/SelectImage'
  import MenuCommonUsers from './MenuCommonUsers'
  export default {
    components: {
      SelectImage,
      ConfirmDelete,
      FormHeader,
      MenuType,
      ActionButton,
      Translate,
      FormContent,
      Availability,
      draggable,
      ModalLoading,
      CustomColorPickerBackgroundAndText: CustomColorPickerBGAndText,
      MenuCommonUsers
    },
    props: {
      editTMP: {
        type: Object,
        require: true
      },
      onSaved: {
        type: Function,
        require: true
      },
      onCancel: {
        type: Function,
        require: true
      },
      onShowMessage: {
        type: Function,
        required: true
      },
      onEdit: {
        type: Function,
        required: true
      },
      scrollPosition: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
      showMenuType:false,
      showConfirmDelete: false,
      contSubmenu: 0,
      dragging: false,
      showCustomColorMenu: false,
    }),
    computed: {
      ...mapState('app',['locale', 'isAdmin', 'contents', 'enterpriseColor', 'BGColor', 'Color', 'BGColorSecundary', 'ColorSecundary', 'GlobalFont', 'collapseContent', 'saving']),
      languages () {
        return this.$store.state.app.Languages
      },
      isNew () {
        return false
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      authType () {
        return this.$store.state.app.authType
      },
      isCommonMenus () {
        return this.$route.path.split('/')[1] === 'common-menus' ? true : false
      },
    },
    mounted () {
      api.getItem('users', true, utils.getUserID()).then(response => {
        this.showCustomColorMenu = response.ShowCustomColorMenu ? true : false
      })  
    },
    methods: {
      handleChangeSort () {
        const body = this.editTMP.Menus.map((item, index) => {
              return ({
                ID: item.ID,
                ORD: index
              })
            })
        api.updateItem('menus', this.enterpriseID.concat('/sort'), body)
          .then(response => {
            console.log(response)
          })
        .catch(error => {
          console.log('error', error)
        })
      },
      handleCollapseContent () {
        this.$store.state.app.collapseContent = !this.$store.state.app.collapseContent
      },
      handleChangeIsTemp () {
        this.$store.state.app.isModified = true
      },
      handleChangeWebAppAsContent () {
        if (this.editTMP.WebAppAsContent && !this.editTMP.WebAppAsContentDomain) this.editTMP.WebAppAsContentDomain = ''
        this.handleChangeIsModified()
      },
      handleChangeWebAppAsLink () {
        if (this.editTMP.WebAppAsLink && !this.editTMP.WebAppAsContentDomain) this.editTMP.WebAppAsContentDomain = ''
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        if (!this.$store.state.app.isModified) this.$store.state.app.isModified = true
      },
      handleAddContent (isMenuWithSubmenu) {
        this.$store.state.app.isModified = true
        if (isMenuWithSubmenu) {
          if (!this.$store.state.app.editTMP.Menus) this.$store.state.app.editTMP.Menus = []
          this.contSubmenu++
          const max = this.$store.state.app.editTMP.Menus.length > 0 ? this.$store.state.app.editTMP.Menus.reduce(function(prev, current) {
            return (prev.ORD > current.ORD) ? prev : current
          }) : 0
          const name = {}
          name[this.locale ? this.locale : 'es'] = 'Submenú'
          this.$store.state.app.editTMP.Menus.push({
            ID: `new_${this.contSubmenu}`,
            isNew: true,
            Name: name,
            /*
            Name: {
              es: 'Submenú'
            },
            */
            ParentID: this.$store.state.app.editTMP.ID,
            Common: 0,
            isSecundary: true,
            ORD: max.ORD + 1
          })
        } else {
          this.showMenuType = true
        }
      },
      handleCloseMenuType (menuType) {
        if (menuType !== null) {
          if (menuType === 1) {
            this.$store.state.app.editTMP = this.$store.state.app.editTMP
            // this.$store.state.app.editTMP.IsMenuWithSubmenu = true
            this.$store.state.app.editTMP.Type = 1
            this.$store.state.app.editTMP.Menus = []
          } else {
            this.type = 0
            // this.$store.state.app.editTMP.IsMenuWithSubmenu = false
            this.$store.state.app.editTMP.Type = 0
            if (!this.$store.state.app.contents) this.$store.state.app.contents = []
            const max = this.$store.state.app.contents && this.$store.state.app.contents.length > 0 ? this.$store.state.app.contents.reduce(function(prev, current) {
                return (prev.ORD > current.ORD) ? prev : current
              }) : { ORD: 0}
            // this.$store.state.app.contents.push(utils.getDefaultContentByType(menuType, max.ORD + 1, this.BGColor))
            this.$store.state.app.contents.push(utils.getDefaultContentByType(menuType, max.ORD + 1, this.BGColor))
          }
        } else {
          if (this.$store.state.app.editTMP.Type !== 1 && this.$store.state.app.editTMP.Type !== 0)
            this.$store.state.app.editTMP.Type = null
        }
        this.showMenuType = false
      },
      handleSubmit () {
        this.$store.state.app.saving = true
        const editTMP = this.$store.state.app.editTMP
        let menus = null
        if (editTMP.Menus) {
          menus = editTMP.Menus.map((item) => {
            return {
              ID: item.ID,
              Name: item.Name,
              Image: item.Image,
              ParentID: item.ParentID,
              IsNew: item.isNew,
              ORD: item.ORD,
              BGColor: item.BGColor,
              TextColor: item.TextColor
              // CustomMenuColor: item.CustomMenuColor
            }
          })
        }
        const body = {
          ID: editTMP.ID,
          Name: editTMP.Name,
          Image: editTMP.Image,
          Alias: editTMP.Alias,
          ParentID: editTMP.ParentID,
          IsNew: editTMP.isNew,
          IsTemp: editTMP.IsTemp ? true : false,
          StartDate: editTMP.StartDate,
          EndDate: editTMP.EndDate,
          NoEndDate: editTMP.NoEndDate,
          ORD: editTMP.ORD,
          Menus: menus,
          Content: this.$store.state.app.contents,
          Type: editTMP.Type,
          Private: editTMP.Private,
          WebAppAsContent: editTMP.WebAppAsContent,
          WebAppAsLink: editTMP.WebAppAsLink,
          WebAppAsContentDomain: editTMP.WebAppAsContentDomain,
          BGColor: editTMP.BGColor,
          TextColor: editTMP.TextColor,
          BGColorContent: editTMP.BGColorContent,
          TextColorContent: editTMP.TextColorContent,
          Availability: editTMP.Availability
          // CustomMenuColor: editTMP.CustomMenuColor
        }
        // console.log('body', body)
        api.updateItem('menus', this.isCommonMenus ? '0000' : this.enterpriseID, body)
          .then(response => {
            this.$store.state.app.saving = false
            // INI temp solve bug on add submenus
            if (this.$store.state.app.editTMP.isNew) {
              const auxID = this.isCommonMenus ? '0000' : this.enterpriseID
              if (auxID) {
                api.getAll(`menus`, false, null, null, null, auxID).then(responseMenus => {
                  responseMenus = responseMenus.map (item => {
                    if (item.Menus) {
                      item.Menus = item.Menus.map (submenu => {
                        submenu.Availability = utils.checkAvailabilityStatus(submenu.Availability)
                        return submenu
                      })
                    }
                    item.Availability = utils.checkAvailabilityStatus(item.Availability)
                    return item
                  })
                  this.$store.state.app.menus = responseMenus
                  const auxEdit = responseMenus.filter(x => x.ID === response.data.newID)
                  if (auxEdit.length > 0) this.onEdit(auxEdit[0])

                })
              }
            }
            // END temp solve bug on add submenus
            if (this.$store.state.app.editTMP.isNew) {
              this.$store.state.app.editTMP.ID = response.data.newID
              this.$store.state.app.editTMP.isNew = false
              this.$store.state.app.contents = null
              this.$store.state.app.editTMP.Menus = null

            }

            if ( this.$store.state.app.editTMP.Menus) {
              for (let i = 0; i < this.$store.state.app.editTMP.Menus.length; i++) {
                if (this.$store.state.app.editTMP.Menus[i].isNew) {
                  this.$store.state.app.editTMP.Menus[i].ID = response.data.menus.filter(x => x.oldID === this.$store.state.app.editTMP.Menus[i].ID)[0].newID
                  this.$store.state.app.editTMP.Menus[i].isNew = false
                }
              }
            }
            if ( this.$store.state.app.contents) {
              for (let i = 0; i < this.$store.state.app.contents.length; i++) {
                if (this.$store.state.app.contents[i].IsNew) {
                  this.$store.state.app.contents[i].ID = response.data.contents.filter(x => x.oldID === this.$store.state.app.contents[i].ID)[0].newID
                  this.$store.state.app.contents[i].IsNew = false
                }
              }
            }
            this.$store.state.app.isModified = false
            if (this.$store.state.app.editTMP.Availability) this.$store.state.app.editTMP.IsActive = utils.checkIsActive(this.$store.state.app.editTMP.Availability)
            else this.$store.state.app.editTMP.IsActive = true
            
            this.onShowMessage(this.$t('menus.messages.update'), 'success')
            this.$store.state.app.editTMP.noRestore = true // utilizado para fozar que no restaure el BK
            //this.handleClear()

            this.onSaved()
            //this.handleClear(this.$store.state.app.editTMP)
          })
        .catch(error => {
          this.$store.state.app.saving = false
          console.log('error', error)
        })
      },
      handleShowDeleteModal () {
        this.showConfirmDelete = !this.showConfirmDelete
      },
      handleCancelDelete () {
      },
      handleUpdateAvailability (value) {
        this.editTMP.Availability = value
      },
      handleDelete () {
        api.deleteItem('menus', this.$store.state.app.editTMP.ID)
          .then(response => {
            if (response.data.affectedRows === 1) {
              if (this.$store.state.app.editTMP.ParentID) {
                this.$store.state.app.menus.filter(x => x.ID === this.$store.state.app.editTMP.ParentID)[0].Menus = this.$store.state.app.menus.filter(x => x.ID === this.$store.state.app.editTMP.ParentID)[0].Menus.filter(x => x.ID !== this.$store.state.app.editTMP.ID)      
              } else {
                this.$store.state.app.menus = this.$store.state.app.menus.filter(x => x.ID !== this.$store.state.app.editTMP.ID)
              }
              this.$store.state.app.isModified = false
              this.onShowMessage(this.$t('menus.messages.delete'), 'success')
              this.onCancel(null)
            }
          })
        this.showConfirmDelete = false
      },
      handleClear () {
        this.contSubmenu = 0
        this.onCancel(null)
      },
      handleChangeCustomMenuColor (BGColor, TextColor) {
        this.$store.state.app.editTMP.BGColor = BGColor
        this.$store.state.app.editTMP.TextColor = TextColor
      },
      handleChangeCustomContentColor (BGColor, TextColor) {
        this.$store.state.app.editTMP.BGColorContent = BGColor
        this.$store.state.app.editTMP.TextColorContent = TextColor
      }
    }
  }
</script>
<style lang="scss" scoped>
  h5 {
    font-weight: 400;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.54);
  }
  .button {
    margin-top: 35px;
  }
  .flip-list-move {
    transition: transform 0s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    min-height: 20px;
  }
  .list-group-item {
    cursor: move !important;
  }
  .list-group-item i {
    cursor: pointer;
  }
  .list-group-item i {
    cursor: pointer;
  }
</style>
